import { render, staticRenderFns } from "./folder-task-files.vue?vue&type=template&id=74cb964e&scoped=true"
import script from "./folder-task-files.vue?vue&type=script&lang=js"
export * from "./folder-task-files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cb964e",
  null
  
)

export default component.exports